import React from 'react'
import logo from '../assets/logo.png'

function Header() {
  return (
        <ul className='header'>
            <li>
              <img style={{}} src={logo}/>
            </li>
            <li className='College-name'>
                Veer Madho Singh Bhandari  Uttarakhand Technical University Dehradun
            </li>
        </ul>
  )
}

export default Header